"use client";

import React, { useState } from "react";
import { Award, ShieldCheck, Star, X, Loader } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
export default function TheNorthEastRooflineExperts() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="124878" id="our-story" className="relative overflow-hidden bg-background text-foreground py-24 lg:py-32">
      {}
      <div className="absolute top-10 left-0 -translate-x-1/4 text-[12rem] md:text-[20rem] font-black text-primary/[0.03] select-none pointer-events-none z-0 leading-none tracking-tighter whitespace-nowrap">
        EST. 2019
      </div>

      <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/3 w-[800px] h-[800px] bg-primary/5 rounded-lg blur-3xl pointer-events-none z-0" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {}
          <div ref={textRef} className={`max-w-[700px] space-y-8 transition-all duration-1000 ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 text-primary font-medium text-sm tracking-wide uppercase">
                <Award className="size-4" />
                <span>Premium Quality Standards</span>
              </div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground font-serif">
                A Legacy of Quality in the North East
              </h2>
            </div>

            <div className="space-y-6 text-lg text-muted-foreground leading-[1.8]">
              <p></p>
              <p>At Five Star Roofline, we’ve built our reputation across County Durham and the North East through honest workmanship, reliable service and attention to detail on every job we take on.

With years of hands-on experience in roofing and uPVC roofline installations, we specialise in fascia, soffit and gutter replacements, dry verge systems, dry ridge systems, EPDM rubber roofing and all aspects of roof repairs.

We take pride in doing things properly — using quality materials, keeping every property clean and tidy, and making sure our customers are looked after from the first quote through to the finished installation.

As a local independent business, customer satisfaction is at the heart of everything we do. Whether it’s a small repair or a full roofline replacement, our goal is always the same: reliable workmanship built to last.</p>
            </div>

            <div className="flex flex-wrap gap-4 pt-4">
              
              
            </div>
          </div>

          {}
          <div ref={imgRef} className={`relative transition-all duration-1000 delay-200 ${isImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative aspect-[4/3] rounded-lg overflow-hidden shadow-2xl border-2 border-primary/20">
              <img src="https://fivestarsroofline.com/wp-content/uploads/2026/05/BA3FE405-0E1B-4E49-92E5-1C346168D68F.jpeg" data-wvc-srcset="https://fivestarsroofline.com/wp-content/uploads/2026/05/BA3FE405-0E1B-4E49-92E5-1C346168D68F.jpeg-wvc-srcset" data-wvc-sizes="https://fivestarsroofline.com/wp-content/uploads/2026/05/BA3FE405-0E1B-4E49-92E5-1C346168D68F.jpeg-wvc-sizes" alt="Five Star Roofline Elite Installation Team" className="w-full h-full object-cover grayscale-[20%] hover:grayscale-0 transition-all duration-700" loading="lazy" />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-lg" />
            </div>

            {}
            <div className="absolute -bottom-8 -left-8 md:-bottom-12 md:-left-12 bg-primary text-primary-foreground p-6 md:p-8 rounded-lg shadow-2xl flex flex-col items-center justify-center w-36 h-36 md:w-48 md:h-48 rotate-[-12deg] border-8 border-background transition-transform hover:rotate-0 duration-500">
              <Star className="size-8 md:size-12 mb-1 md:mb-2 fill-current" />
              <span className="font-bold text-center leading-tight text-sm md:text-lg tracking-tight font-serif">
                FIVE STAR<br />QUALITY
              </span>
            </div>

            {}
            <div className="absolute -top-6 -right-6 bg-card text-card-foreground p-4 rounded-lg shadow-xl border border-primary/20 flex items-center gap-3 animate-bounce" style={{
            animationDuration: "3s"
          }}>
              <div className="bg-primary/10 p-2 rounded-lg">
                <ShieldCheck className="size-6 text-primary" />
              </div>
              <div>
                <p className="text-sm font-bold leading-none">Fully</p>
                <p className="text-xs text-muted-foreground uppercase tracking-widest">Guaranteed</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      {isFormOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
          <div className="relative w-full max-w-lg bg-card border border-border rounded-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-300">
            <div className="absolute top-4 right-4">
              <Button variant="ghost" size="icon" onClick={() => setIsFormOpen(false)} className="text-muted-foreground hover:text-foreground rounded-lg">
                <X className="size-6" />
              </Button>
            </div>
            
            <div className="p-8">
              <div className="mb-6">
                <h3 className="text-2xl font-bold font-serif text-foreground">Get a Free Quote</h3>
                <p className="text-muted-foreground">Fill in your details and we'll get back to you shortly.</p>
              </div>

              <FormProvider formId="get_quote_form_gallery" sectionName="TheNorthEastRooflineExperts" defaultValues={{
            name: "",
            phone: "",
            email: "",
            service: "",
            message: ""
          }} validationRules={{
            name: {
              required: true
            },
            phone: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            }
          }}>
                <QuoteFormContent onClose={() => setIsFormOpen(false)} />
              </FormProvider>
            </div>
          </div>
        </div>}
    </section>;
}
function QuoteFormContent({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="text-center py-8 space-y-4">
        <div className="size-16 bg-primary/20 text-primary rounded-lg flex items-center justify-center mx-auto">
          <ShieldCheck className="size-10" />
        </div>
        <h4 className="text-xl font-bold text-foreground">Request Received</h4>
        <p className="text-muted-foreground">{successMessage}</p>
        <Button onClick={onClose} className="w-full rounded-lg">Close</Button>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <label className="text-sm font-medium text-foreground">Full Name</label>
        <input name="name" required className="w-full px-4 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary/50 outline-none transition-all" placeholder="John Doe" />
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">Phone Number</label>
          <input name="phone" type="tel" required className="w-full px-4 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary/50 outline-none transition-all" placeholder="07123 456789" />
        </div>
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">Email Address</label>
          <input name="email" type="email" required className="w-full px-4 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary/50 outline-none transition-all" placeholder="john@example.com" />
        </div>
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium text-foreground">Service Required</label>
        <select name="service" className="w-full px-4 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary/50 outline-none transition-all">
          <option value="">Select a service...</option>
          <option value="roofline">uPVC Roofline</option>
          <option value="dry-verge">Dry Verge / Ridge</option>
          <option value="epdm">EPDM Rubber Roofing</option>
          <option value="other">Other Inquiry</option>
        </select>
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium text-foreground">Message (Optional)</label>
        <textarea name="message" rows={3} className="w-full px-4 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary/50 outline-none transition-all resize-none" placeholder="Tell us about your project..." />
      </div>

      {submitError && <p className="text-sm text-destructive bg-destructive/10 p-3 rounded-lg">{submitError}</p>}

      <Button type="submit" disabled={isSubmitting} className="w-full rounded-lg h-12 text-lg font-bold shadow-lg shadow-primary/20">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Sending...
          </> : "Submit Request"}
      </Button>
    </form>;
}